export default {"src":"/_next/static/media/time.a1dd838d.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};